export default "__VITE_ASSET__Czt9IBlI__"